import type { JSX } from 'react'

export const PlayIcon = ({ filled }: { filled?: boolean }): JSX.Element => (
  <>
    <use
      href='#playSolidIcon'
      height='100%'
      width='100%'
      fillOpacity={!filled ? 0 : 1}
    />
    <use href='#playIcon' height='100%' width='100%' />
  </>
)
